import React from 'react';
import './Sidebar.css';
import { ELEMENT_TYPES } from './ElementRegistry';
import { faHeart } from '@fortawesome/free-solid-svg-icons';

function Sidebar({ addElement, isPreviewMode }) {
  if (isPreviewMode) return null;
  
  const handleDragStart = (e, elementType) => {
    e.dataTransfer.setData('elementType', elementType);
  };
  
  return (
    <div className="sidebar right-sidebar">
      <div className="sidebar-elements">
        <div className="sidebar-section">
          <button 
            className="sidebar-button"
            onClick={() => addElement(ELEMENT_TYPES.BACKGROUND)}
            title="Add Background"
          >
            <div className="icon-container">
              <svg width="24" height="24" viewBox="0 0 24 24" stroke="#666" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="1.5" />
                <path d="M3 16L7 12L10 15L17 8L21 12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <span className="button-label">Background</span>
          </button>
          
          <button 
            className="sidebar-button"
            onClick={() => {
              const event = new CustomEvent('toggle-layer-panel');
              window.dispatchEvent(event);
            }}
            title="Toggle Layers Panel"
          >
            <div className="icon-container">
              <svg width="24" height="24" viewBox="0 0 24 24" stroke="#666" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17L12 22L22 17" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 12L12 17L22 12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span className="button-label">Layers</span>
          </button>
          
          <button 
            className="sidebar-button"
            onClick={() => addElement('text')}
            title="Add Text"
          >
            <div className="icon-container">
              <span className="icon">T</span>
            </div>
            <span className="button-label">Text</span>
          </button>
          
          <button 
            className="sidebar-button"
            onClick={() => addElement('image')}
            title="Add Image"
          >
            <div className="icon-container">
              <svg width="24" height="24" viewBox="0 0 24 24" stroke="#666" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM5 19V5H19V19H5Z" strokeWidth="1.5" />
                <path d="M14.5 11L11 15.5L8.5 12.5L5 17H19L14.5 11Z" strokeWidth="1.5" />
              </svg>
            </div>
            <span className="button-label">Image</span>
          </button>
          
          <button 
            className="sidebar-button"
            onClick={() => addElement('video')}
            title="Add Video"
          >
            <div className="icon-container">
              <svg width="24" height="24" viewBox="0 0 24 24" stroke="#666" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="5" width="18" height="14" rx="2" strokeWidth="1.5" />
                <circle cx="12" cy="12" r="3" strokeWidth="1.5" />
              </svg>
            </div>
            <span className="button-label">Uploads</span>
          </button>

          <button 
            className="sidebar-button"
            onClick={() => addElement(ELEMENT_TYPES.SHAPE)}
            title="Add Shape"
          >
            <div className="icon-container">
              <svg width="24" height="24" viewBox="0 0 24 24" stroke="#666" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="6" height="6" rx="1" strokeWidth="1.5" />
                <rect x="15" y="3" width="6" height="6" rx="1" strokeWidth="1.5" />
                <rect x="15" y="15" width="6" height="6" rx="1" strokeWidth="1.5" />
                <path d="M9 15L3 21M3 15L9 21" strokeWidth="1.5" />
              </svg>
            </div>
            <span className="button-label">Shape</span>
          </button>

          <button 
            className="sidebar-button"
            onClick={() => addElement('icon', {
              icon: faHeart,
              style: {
                width: '48px',
                height: '48px',
                color: '#333333',
                opacity: 1,
                transform: 'rotate(0deg)'
              }
            })}
            title="Add Icon"
          >
            <div className="icon-container">
              <svg width="24" height="24" viewBox="0 0 24 24" stroke="#666" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span className="button-label">Icons</span>
          </button>

          <button 
            className="sidebar-button"
            onClick={() => addElement(ELEMENT_TYPES.RSVP_BUTTON)}
            title="Add RSVP Button"
          >
            <div className="icon-container">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="8" width="16" height="8" rx="2" stroke="#666" strokeWidth="1.5"/>
                <path d="M9 12H15" stroke="#666" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <span className="button-label">RSVP Button</span>
          </button>
          
          <button 
            className="sidebar-button"
            onClick={() => addElement(ELEMENT_TYPES.RSVP_FORM)}
            title="Add RSVP Form"
          >
            <div className="icon-container">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="18" height="18" rx="2" stroke="#666" strokeWidth="1.5"/>
                <path d="M7 8H17" stroke="#666" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M7 12H17" stroke="#666" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M7 16H13" stroke="#666" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <span className="button-label">RSVP Form</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Sidebar; 